// extracted by mini-css-extract-plugin
module.exports = {"user-answers":"styles_user-answers__3gaXO","table":"styles_table__3XMCe","row":"styles_row__61X95","email":"styles_email__9_fD5"};